import type { RouteActionTarget } from './types';

export const ROUTE_MAP_HEIGHT = 360;
export const ROUTE_LINE_WEIGHT = 3;
export const ROUTE_LINE_OPACITY = 0.9;
export const GPS_ROUTE_RETENTION_DAYS = 3;

export const DELIVERED_STATUS_TITLE = 'Entrega já realizada';
export const IN_PROGRESS_TIME_LABEL = 'Agora';

export const ROUTE_MANAGER_ACTION_CAPTION = 'Executado pelo admin';

export enum DELIVERY_ACTION_EVENT {
  ENTREGA_PENDENTE_ACEITA_BY_DELIVERYMAN = 'ENTREGA_PENDENTE_ACEITA_BY_DELIVERYMAN',
  ENTREGA_ASSOCIADA_ACEITA_BY_DELIVERYMAN = 'ENTREGA_ASSOCIADA_ACEITA_BY_DELIVERYMAN',
  ENTREGA_ASSOCIADA_ACEITA_BY_MANAGER = 'ENTREGA_ASSOCIADA_ACEITA_BY_MANAGER',
  ENTREGA_ASSOCIADA_ACEITA_BY_PLACE = 'ENTREGA_ASSOCIADA_ACEITA_BY_PLACE',
  ENTREGA_CHEGOU_NA_LOJA = 'ENTREGA_CHEGOU_NA_LOJA',
  ENTREGA_CHEGOU_NA_LOJA_BY_MANAGER = 'ENTREGA_CHEGOU_NA_LOJA_BY_MANAGER',
  ENTREGA_SAIU_DA_LOJA = 'ENTREGA_SAIU_DA_LOJA',
  ENTREGA_SAIU_DA_LOJA_BY_DELIVERYMAN = 'ENTREGA_SAIU_DA_LOJA_BY_DELIVERYMAN',
  ENTREGA_SAIU_DA_LOJA_BY_MANAGER = 'ENTREGA_SAIU_DA_LOJA_BY_MANAGER',
  ENTREGA_CHEGOU_NO_CLIENTE_BY_DELIVERYMAN = 'ENTREGA_CHEGOU_NO_CLIENTE_BY_DELIVERYMAN',
  ENTREGA_CHEGOU_NO_CLIENTE_BY_MANAGER = 'ENTREGA_CHEGOU_NO_CLIENTE_BY_MANAGER',
  ENTREGA_ENTREGUE = 'ENTREGA_ENTREGUE',
  ENTREGA_ENTREGUE_BY_MANAGER = 'ENTREGA_ENTREGUE_BY_MANAGER',
  CORRIDA_RETORNOU_LOJA = 'CORRIDA_RETORNOU_LOJA',
  ENTREGA_FINALIZADA_BY_DELIVERYMAN = 'ENTREGA_FINALIZADA_BY_DELIVERYMAN',
  ENTREGA_FINALIZADA_BY_MANAGER = 'ENTREGA_FINALIZADA_BY_MANAGER',
}

export const DELIVERY_ACTION_EVENTS: {
  id: RouteActionTarget;
  label: string;
  events: DELIVERY_ACTION_EVENT[];
}[] = [
  {
    id: 'accepted',
    label: 'Aceitou a entrega',
    events: [
      DELIVERY_ACTION_EVENT.ENTREGA_PENDENTE_ACEITA_BY_DELIVERYMAN,
      DELIVERY_ACTION_EVENT.ENTREGA_ASSOCIADA_ACEITA_BY_DELIVERYMAN,
      DELIVERY_ACTION_EVENT.ENTREGA_ASSOCIADA_ACEITA_BY_MANAGER,
      DELIVERY_ACTION_EVENT.ENTREGA_ASSOCIADA_ACEITA_BY_PLACE,
    ],
  },
  {
    id: 'arrived-store',
    label: 'Chegou na loja',
    events: [
      DELIVERY_ACTION_EVENT.ENTREGA_CHEGOU_NA_LOJA,
      DELIVERY_ACTION_EVENT.ENTREGA_CHEGOU_NA_LOJA_BY_MANAGER,
    ],
  },
  {
    id: 'left-store',
    label: 'Saiu da loja',
    events: [
      DELIVERY_ACTION_EVENT.ENTREGA_SAIU_DA_LOJA,
      DELIVERY_ACTION_EVENT.ENTREGA_SAIU_DA_LOJA_BY_DELIVERYMAN,
      DELIVERY_ACTION_EVENT.ENTREGA_SAIU_DA_LOJA_BY_MANAGER,
    ],
  },
  {
    id: 'arrived-client',
    label: 'Chegou no cliente',
    events: [
      DELIVERY_ACTION_EVENT.ENTREGA_CHEGOU_NO_CLIENTE_BY_DELIVERYMAN,
      DELIVERY_ACTION_EVENT.ENTREGA_CHEGOU_NO_CLIENTE_BY_MANAGER,
    ],
  },
  {
    id: 'delivered',
    label: 'Entregou',
    events: [
      DELIVERY_ACTION_EVENT.ENTREGA_ENTREGUE,
      DELIVERY_ACTION_EVENT.ENTREGA_ENTREGUE_BY_MANAGER,
    ],
  },
  {
    id: 'returned',
    label: 'Retornou ao estabelecimento',
    events: [DELIVERY_ACTION_EVENT.CORRIDA_RETORNOU_LOJA],
  },
  {
    id: 'finished',
    label: 'Finalizou',
    events: [
      DELIVERY_ACTION_EVENT.ENTREGA_FINALIZADA_BY_DELIVERYMAN,
      DELIVERY_ACTION_EVENT.ENTREGA_FINALIZADA_BY_MANAGER,
    ],
  },
];
